import Service                            from '@/api/service';
import ky                                 from 'ky';
import i18n                               from '@/lang';
import { centToEuro, getKeyValueProfile } from '@/composables/formatData';

export const PROFORMA_STATUS_EDITED = 'edited';
export const PROFORMA_STATUS_VALIDATION_IN_PROGRESS = 'validation_in_progress';
export const PROFORMA_STATUS_TO_BILL = 'to_bill';
export const PROFORMA_STATUS_BILLED = 'billed';

export function useProformaStatusList(proforma) {

  const messages = i18n.global.messages[i18n.global.locale];
  return [
    {
      key   : PROFORMA_STATUS_EDITED,
      value : messages.proforma.status.edited,
      color : 'grey-300'
    },
    {
      key   : PROFORMA_STATUS_VALIDATION_IN_PROGRESS,
      value : messages.proforma.status.validation_in_progress,
      color : 'yellow'
    },
    {
      key   : PROFORMA_STATUS_TO_BILL,
      value : messages.proforma.status.to_bill,
      color : 'orange'
    },
    {
      key      : PROFORMA_STATUS_BILLED,
      value    : messages.proforma.status.billed,
      color    : 'green',
      disabled : proforma?.id ? !proforma.invoiceId : false
    }
  ];
}

export async function getProformaBase64Data(proformaId, tenantId) {

  try {
    const proforma = await Service.getProforma(tenantId, proformaId);

    if (proforma?.documentId) {
      const url = await Service.getDocumentFromS3(tenantId, proforma.documentId);
      const response = await ky.get(url.url);

      if (!response.body) {
        return undefined;
      }

      return window.URL.createObjectURL(await response.blob());
    }

    return undefined;

  } catch {
    return undefined;
  }
}

export async function useFormatProformas(tenantId, proformas) {

  const formattedProformas = [];
  for (const proforma of proformas) {

    const formattedProforma = await useFormatProforma(tenantId, proforma);

    formattedProformas.push(formattedProforma);
  }

  return formattedProformas;
}

async function useFormatProforma(tenantId, proforma) {

  if (proforma.invoice?.id) {
    proforma.invoice = {
      id          : proforma.invoice.id,
      paymentDate : proforma.invoice.paymentDate,
      status      : proforma.invoice.status,
      owner       : await getKeyValueProfile(tenantId, proforma.invoice.userId),
      property    : proforma.property
    };
  }

  return {
    ...proforma,
    owner  : await getKeyValueProfile(tenantId, proforma.recipientId),
    amount : proforma.amount ? centToEuro(proforma.amount) : undefined
  };
}
